module.exports = "/_next/static/images/apple-touch-icon-180-951dd38f6c787fa77c70e8b82549753f.png";